webpackJsonp([101],{

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__ = __webpack_require__(319);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "init",
    value: function init() {
      this.setEntryPageCookie();
      this.setUtmCookies();
    }
  }, {
    key: "getUrlParam",
    value: function getUrlParam(name) {
      return decodeURIComponent((new RegExp("[?|&]".concat(name, "=([^&;]+?)(&|#|;|$)")).exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
    }
  }, {
    key: "getUrlLocation",
    value: function getUrlLocation() {
      return escape(window.location.pathname);
    }
  }, {
    key: "setEntryPageCookie",
    value: function setEntryPageCookie() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["c" /* hasCookie */])('entry_page')) {
        Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["a" /* createCookie */])('entry_page', this.getUrlLocation(), 999999);
      }
    }
  }, {
    key: "setUtmCookies",
    value: function setUtmCookies() {
      var _this = this;

      var utmParams = ['campaign', 'source', 'medium', 'content', 'term'];
      var override = this.getUrlParam('utm_nooverride') !== '1';

      var hasFirstTimestamp = Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["c" /* hasCookie */])('f_iso');

      var timestamp = new Date().toISOString();
      utmParams.forEach(function (param) {
        var utmParam = "utm_".concat(param);

        var utmValue = _this.getUrlParam(utmParam);

        if (!utmValue) return;

        if (!hasFirstTimestamp) {
          Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["a" /* createCookie */])("f_".concat(utmParam), utmValue, 365);

          Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["a" /* createCookie */])('f_iso', timestamp, 365);
        }

        if (!hasFirstTimestamp || override) {
          Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["a" /* createCookie */])("l_".concat(utmParam), utmValue, 365);

          Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["a" /* createCookie */])('l_iso', timestamp, 365);
        }
      });
    }
  }, {
    key: "getCookie",
    value: function getCookie(name) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["b" /* getCookie */])(name);
    }
  }, {
    key: "createCookie",
    value: function createCookie(name, value, days) {
      Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["a" /* createCookie */])(name, value, days);
    }
  }, {
    key: "hasCookie",
    value: function hasCookie(name) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_cookie__["c" /* hasCookie */])(name);
    }
  }]);

  return _default;
}();



/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1556);


/***/ }),

/***/ 1556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../globals/jquery.js
var jquery = __webpack_require__(12);

// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(87);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ../globals/Rover.js
var Rover = __webpack_require__(15);

// CONCATENATED MODULE: ../utilities/ajax.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var ajax_initJQueryHeaders = function initJQueryHeaders() {
  jquery["default"].ajaxSetup({
    headers: Rover["default"].api.getSourceHeader()
  });
  Object(jquery["default"])(document).ajaxSend(function (e, jqxhr, settings) {
    var token = Rover["default"].utils.getCsrfToken();
    if (!token) return;

    if (window.isRoverURL(settings.url)) {
      jqxhr.setRequestHeader('X-CSRFToken', token);
    }
  });
};

var ajax_initAxiosHeaders = function initAxiosHeaders() {
  axios_default.a.interceptors.request.use(function (config) {
    // if we're requesting a rover url
    if (config.url.includes(window.location.host) || config.url.startsWith('/') || config.url.startsWith('./') || config.url.startsWith('../')) {
      var clone = _objectSpread({}, config); // clone the config and add our custom headers


      clone.headers.common = _objectSpread(_objectSpread({}, config.headers.common), Rover["default"].api.getSourceHeader());
      var token = Rover["default"].utils.getCsrfToken();

      if (token) {
        clone.headers.common['X-CSRFToken'] = token;
      }

      return clone;
    } // non-rover urls get NOTHING, to avoid CORS issues


    return config;
  }, function (error) {
    return Promise.reject(error);
  });
};

function ajax_init() {
  ajax_initJQueryHeaders();
  ajax_initAxiosHeaders();
}

/* harmony default export */ var ajax = ({
  init: ajax_init
});
// EXTERNAL MODULE: ../utilities/auth.js
var auth = __webpack_require__(1035);

// CONCATENATED MODULE: ../utilities/carousels.js


function carousels_init() {
  /**
   * Ajax support for carousel images.
   * Whenever a carousel slides, look for images in the
   * next slide that need to be loaded asynchronously.
   */
  Object(jquery["default"])(document).on('slide.bs.carousel', '[data-ride="carousel"]', function (e) {
    // Find the images in the the new slide that need loading
    var srcAttrName = 'data-src',
        loadingClass = 'rover-loading',
        $newSlide = Object(jquery["default"])(e.relatedTarget),
        $imagesToProcess = $newSlide.find("img[".concat(srcAttrName, "]"));
    $imagesToProcess.each(function () {
      // Find the image source that needs to be loaded
      var $img = Object(jquery["default"])(this),
          newSrc = $img.attr(srcAttrName),
          $tmpImg = Object(jquery["default"])('<img>'); // Define behavior for when the image is finished loading

      $tmpImg.load(function () {
        $img.removeAttr(srcAttrName);
        $img.attr('src', newSrc);
        $img.unwrap();
        $newSlide.trigger('loaded');
      }); // Update UI to reflect loading and start loading image

      $img.wrap("<div class=\"img-responsive ".concat(loadingClass, "\"></div>"));
      $tmpImg.attr('src', newSrc);
    });
  });
}

/* harmony default export */ var carousels = ({
  init: carousels_init
});
// EXTERNAL MODULE: ../utilities/events.js
var events = __webpack_require__(853);

// EXTERNAL MODULE: ../utilities/Alerts.js
var Alerts = __webpack_require__(325);

// CONCATENATED MODULE: ../utilities/flag-listing.js



var flag_listing_flagFormSubmitSuccess = function flagFormSubmitSuccess(response, status, xhr, $form) {
  $form.closest('.js-feedback-modal').modal('hide');
  Alerts["a" /* default */].showToast({
    severity: 'success',
    message: "Thank you for flagging this. We'll look at it as soon as possible"
  });
  Object(jquery["default"])(window).scrollTop(0);
};

function flag_listing_init() {
  this.$flagForm = Object(jquery["default"])('.js-flag-form');
  this.$flagForm.validate({
    rules: {
      comment: {
        required: true,
        minWords: 4
      }
    }
  });
  this.$flagForm.autoDisableAndValidateAjaxForm({
    success: flag_listing_flagFormSubmitSuccess,
    resetForm: true
  });

  if (window.location.hash === '#flag_dialog') {
    Object(jquery["default"])('.js-flag-button').trigger('click');
  }
}

/* harmony default export */ var flag_listing = ({
  init: flag_listing_init
});
// CONCATENATED MODULE: ../utilities/gus-tips.js


function gus_tips_init() {
  var $gusTips = Object(jquery["default"])('.js-gus-tip');
  $gusTips.each(function () {
    var $this = Object(jquery["default"])(this);
    var shouldShow = jquery["default"].cookie($this.data('gus-tip-cookie')) !== 'dismissed';

    if (shouldShow) {
      $this.show();
    }
  });
}

function handleGusTipDismiss() {
  var $gusTip = Object(jquery["default"])(this).closest('.js-gus-tip');
  jquery["default"].cookie($gusTip.data('gus-tip-cookie'), 'dismissed', {
    expires: 180
  });
  $gusTip.hide();
}

/* harmony default export */ var gus_tips = ({
  init: gus_tips_init,
  handleGusTipDismiss: handleGusTipDismiss
});
// EXTERNAL MODULE: ../utilities/translation.js
var translation = __webpack_require__(37);

// CONCATENATED MODULE: ../utilities/text-utilities.js



function getWords(s) {
  var trimmedString = s.replace(/(^\s*)|(\s*$)/gi, '');
  if (trimmedString === '') return [];
  return trimmedString.split(/\s+/);
}

function getWordCount(s) {
  return getWords(s).length;
}

function getCharacterCount(s) {
  return s.replace(/(^\s*)|(\s*$)/gi, '').length;
}

jquery["default"].fn.wordCount = function wordCount() {
  return getWordCount(Object(jquery["default"])(this).val());
};

function updateWordCount(e) {
  var $el = Object(jquery["default"])(e.currentTarget);
  var $counter = $el.siblings().find('.js-word-count-input-counter');
  var $text = $el.siblings().find('.js-word-count-input-text');
  var minCharacters = $el.attr('data-min-characters');

  if (minCharacters != null) {
    var characterCount = getCharacterCount($el.val());
    var charactersNeeded;
    if (minCharacters) charactersNeeded = minCharacters - characterCount;
    $counter.html(Math.max(0, charactersNeeded));

    if (!minCharacters) {
      return;
    }

    if (characterCount === 0) {
      $text.html(translation["default"]._('characters minimum required'));
    } else if (charactersNeeded > 0) {
      $counter.addClass('text-danger');
      $text.addClass('text-danger');
      $text.html(translation["default"]._('more characters needed'));
    } else {
      $counter.removeClass('text-danger');
      $text.removeClass('text-danger');
      $text.html('<i class="text-primary rover-icon rover-icon-in-check-mark">');
      $counter.html('');
    }
  } else {
    var wordCount = getWordCount($el.val());
    var wordsNeeded;
    var minWords = $el.attr('data-min-words');
    if (minWords) wordsNeeded = minWords - wordCount;
    $counter.html(Math.max(0, wordsNeeded));

    if (!minWords) {
      return;
    }

    if (wordCount === 0) {
      $text.html(translation["default"]._('words minimum required'));
    } else if (wordsNeeded > 0) {
      $counter.addClass('text-danger');
      $text.addClass('text-danger');
      $text.html(translation["default"]._('more words needed'));
    } else {
      $counter.removeClass('text-danger');
      $text.removeClass('text-danger');
      $text.html('<i class="text-primary rover-icon rover-icon-in-check-mark">');
      $counter.html('');
    }
  }
}

function updateCharCount(evt) {
  var $target = Object(jquery["default"])(evt.target);
  $target.siblings().find('.js-char-count-input-counter').html($target.val().length);
}

function initWordCount() {
  Object(jquery["default"])('.js-word-count-input').trigger('input');
}

function initCharCount() {
  Object(jquery["default"])('.js-char-count-input').trigger('input');
}

function text_utilities_init() {
  Object(jquery["default"])('.js-word-count-input').on('input', updateWordCount);
  Object(jquery["default"])('.js-char-count-input').on('input', updateCharCount);
  initWordCount();
  initCharCount();
}

/* harmony default export */ var text_utilities = ({
  init: text_utilities_init,
  getWords: getWords,
  getWordCount: getWordCount,
  getCharacterCount: getCharacterCount,
  updateWordCount: updateWordCount,
  updateCharCount: updateCharCount,
  initWordCount: initWordCount,
  initCharCount: initCharCount
});
// EXTERNAL MODULE: ../utilities/validation.js
var validation = __webpack_require__(1040);

// CONCATENATED MODULE: ../utilities/console.js
function console_init() {
  /**
   * Ensure that window always has the hasOwnProperty method on it, as
   * older versions of IE do not have this, and we are testing for jQuery presence
   * using it.
   */
  window.hasOwnProperty = function (obj) {
    return !!this[obj];
  };
  /**
   * Prevent errors from calls to console.* from browsers that don't support it.
   */


  if (!window.hasOwnProperty('console')) {
    window.console = {
      assert: function assert() {},
      clear: function clear() {},
      count: function count() {},
      debug: function debug() {},
      dir: function dir() {},
      dirxml: function dirxml() {},
      error: function error() {},
      exception: function exception() {},
      group: function group() {},
      groupCollapsed: function groupCollapsed() {},
      groupEnd: function groupEnd() {},
      info: function info() {},
      log: function log() {},
      profile: function profile() {},
      profileEnd: function profileEnd() {},
      table: function table() {},
      time: function time() {},
      timeEnd: function timeEnd() {},
      timeStamp: function timeStamp() {},
      trace: function trace() {},
      warn: function warn() {}
    };
  }
}

/* harmony default export */ var console = ({
  init: console_init
});
// CONCATENATED MODULE: ../utilities/jquery-fixes.js
/* eslint-disable filenames/match-regex */


function jquery_fixes_init() {
  /**
   * Fix jQuery show to work better with Bootstrap hidden/hide classes
   * https://github.com/twbs/bootstrap/issues/9237
   */
  // eslint-disable-next-line prefer-destructuring
  var show = jquery["default"].fn.show;

  jquery["default"].fn.show = function () {
    this.removeClass('hidden hide');
    return show.call(this);
  };
  /**
   * Recursively strip whitespace between child elements.
   */


  jquery["default"].fn.removeWhitespace = function () {
    this.contents().filter(function () {
      if (this.nodeType === 3) {
        return !/\S/.test(this.nodeValue);
      }

      Object(jquery["default"])(this).removeWhitespace();
      return false;
    }).remove();
    return this;
  };
}

/* harmony default export */ var jquery_fixes = ({
  init: jquery_fixes_init
});
// EXTERNAL MODULE: ../utilities/fireDataLayerEvent.client.js
var fireDataLayerEvent_client = __webpack_require__(385);

// EXTERNAL MODULE: ../utilities/storage.js
var storage = __webpack_require__(217);

// CONCATENATED MODULE: ../utilities/saveNavigationEvent.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var EVENTS_KEY = 'navigationEvents';

var saveNavigationEvent_saveNavigationEvent = function saveNavigationEvent(event) {
  if (event && event.event) {
    var data = storage["localStorage"].getItem(EVENTS_KEY);
    var navigationEvents = data && JSON.parse(data) || [];
    var newNavigationEvents = [].concat(_toConsumableArray(navigationEvents), [event]);
    var newData = JSON.stringify(newNavigationEvents);
    storage["localStorage"].setItem(EVENTS_KEY, newData);
  }
};

/* harmony default export */ var utilities_saveNavigationEvent = (saveNavigationEvent_saveNavigationEvent);
// CONCATENATED MODULE: ../utilities/loadNavigationEventsIntoDataLayer.js




var loadNavigationEventsIntoDataLayer_loadNavigationEventsIntoDataLayer = function loadNavigationEventsIntoDataLayer() {
  var data = storage["localStorage"].getItem(EVENTS_KEY);
  var navigationEvents = data && JSON.parse(data) || [];
  navigationEvents.forEach(function (event) {
    return Object(fireDataLayerEvent_client["a" /* default */])(event);
  });
  storage["localStorage"].setItem(EVENTS_KEY, JSON.stringify([]));
};

/* harmony default export */ var utilities_loadNavigationEventsIntoDataLayer = (loadNavigationEventsIntoDataLayer_loadNavigationEventsIntoDataLayer);
// CONCATENATED MODULE: ../utilities/applyNavigationEventClickHandlers.js


var applyNavigationEventClickHandlers_applyNavigationEventClickHandlers = function applyNavigationEventClickHandlers() {
  var links = Array.prototype.slice.call(document.querySelectorAll('[data-nav-event]'));
  links.forEach(function (link) {
    var navEvent = link.getAttribute('data-nav-event');

    if (navEvent) {
      link.addEventListener('click', function () {
        utilities_saveNavigationEvent({
          event: navEvent
        });
      });
    }
  });
};

/* harmony default export */ var utilities_applyNavigationEventClickHandlers = (applyNavigationEventClickHandlers_applyNavigationEventClickHandlers);
// EXTERNAL MODULE: ./js/components/rover_modal.js
var rover_modal = __webpack_require__(307);

// CONCATENATED MODULE: ./js/utilities/modals.js




function showModal() {
  var options = {
    content: Object(jquery["default"])(Object(jquery["default"])(this).attr('data-target')).html(),
    title: Object(jquery["default"])(this).attr('data-title'),
    disableCancel: Object(jquery["default"])(this).attr('data-modal-blocking'),
    padding: !(Object(jquery["default"])(this).attr('data-modal-padding') === 'false')
  };
  var modal = new rover_modal["a" /* default */](options);
  modal.open();
}

function initializeBlockingModal() {
  if (Rover["default"].disable_blocking_modal) return;
  if (Object(jquery["default"])(document.body).hasClass('js-disable-blocking-modal')) return;
  Rover["default"].blocking_modals.handleBlockingModal();
}

function modals_init() {
  initializeBlockingModal();
}

/* harmony default export */ var modals = ({
  init: modals_init,
  showModal: showModal,
  initializeBlockingModal: initializeBlockingModal
});
// CONCATENATED MODULE: ./js/utilities/buttons.js





function disableClick() {
  return false;
}

function selectRadio() {
  Object(jquery["default"])(this).find('input[type="radio"]:not(:disabled)').prop('checked', true);
}

function handleClockButtonClick(e) {
  e.preventDefault();
  var $this = Object(jquery["default"])(this);
  var $triggerTarget = Object(jquery["default"])($this.attr('data-trigger-target'));

  if (!$triggerTarget.length) {
    $triggerTarget = $this.find('.js-timepicker');
  }

  $triggerTarget.focus();
  $triggerTarget.timepicker('show');
}

function handleCalendarButtonClick(e) {
  e.preventDefault();
  var $this = Object(jquery["default"])(this);
  var $triggerTarget = Object(jquery["default"])($this.attr('data-trigger-target'));

  if (!$triggerTarget.length) {
    $triggerTarget = $this.find('.js-date-picker');
  }

  $triggerTarget.datepicker('show');
}

function buttons_init() {
  var btn = jquery["default"].fn.button.noConflict(); // reverts $.fn.button to jqueryui btn

  jquery["default"].fn.btn = btn; // assigns bootstrap button functionality to $.fn.btn

  Object(jquery["default"])('.rover-btn').btn(); // Enable button toggling functionality for rover buttons. Bootstrap hardcodes
  // their listener on .btn, so we have to do the same for .rover-btn

  Object(jquery["default"])(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
    var $roverBtn = Object(jquery["default"])(e.target); // Account for the case when the click event occurred on something
    // inside the rover button

    if (!$roverBtn.hasClass('rover-btn')) {
      $roverBtn = $roverBtn.closest('.rover-btn');
    }

    $roverBtn.btn('toggle');
    e.preventDefault();
  });
  Object(jquery["default"])('.js-gus-tip-dismiss').on('click', gus_tips.handleGusTipDismiss);
  Object(jquery["default"])('.js-show-modal').on('click', modals.showModal);
  Object(jquery["default"])('.js-disable-click').on('click', disableClick);
  Object(jquery["default"])(document).on('click', '.js-datepicker-calendar-trigger', handleCalendarButtonClick);
  Object(jquery["default"])(document).on('click', '.js-timepicker-clock-trigger', handleClockButtonClick);
  Object(jquery["default"])(document).on('click', '.js-clickable-for-radio', selectRadio);
  Object(jquery["default"])(document).on('click', '[data-record-click-event]', events["a" /* default */].recordClickEventHandler);
}

/* harmony default export */ var buttons = ({
  init: buttons_init,
  disableClick: disableClick,
  handleClockButtonClick: handleClockButtonClick,
  handleCalendarButtonClick: handleCalendarButtonClick
});
// EXTERNAL MODULE: ../globals/Mustache.js
var Mustache = __webpack_require__(142);

// EXTERNAL MODULE: ./js/core/views/gallery_modal.js
var gallery_modal = __webpack_require__(855);

// CONCATENATED MODULE: ./js/utilities/galleries.js





function initializeGalleries() {
  var slides = [];
  var images = Object(jquery["default"])('.js-shareable-image');
  var template = Mustache["default"].template('new_design/social/modal_sharing_buttons');
  images.each(function (i, image) {
    var $image = Object(jquery["default"])(image);
    var shareButtons = template.render({
      imageToShare: $image.attr('data-image-to-share'),
      imageThumbnail: $image.attr('data-image-thumbnail'),
      urlToShare: $image.attr('data-url-to-share'),
      contentType: $image.attr('data-content-type'),
      objectId: $image.attr('data-object-id'),
      campaign: $image.attr('data-campaign'),
      trackingContent: $image.attr('data-tracking-content'),
      caption: $image.attr('data-caption'),
      shareLocation: $image.attr('data-share-location'),
      hideable: $image.attr('data-hideable') === 'true',
      hidden: $image.attr('data-hidden') === 'true'
    });
    var slide = {
      type: 'image',
      src: $image.attr('href'),
      unsafeHtmlCaption: shareButtons
    };
    slides.push(slide);
  });
  var staysGalleryModal = new gallery_modal["a" /* default */]({
    classes: 'stays-gallery-modal',
    slides: slides
  });
  images.each(function (i, image) {
    var $image = Object(jquery["default"])(image);

    (function (val) {
      $image.off('click').on('click', function (e) {
        e.preventDefault();
        if (staysGalleryModal) staysGalleryModal.openTo(val);
      });
    })(i);
  });
}

function galleries_init() {
  initializeGalleries();
}

/* harmony default export */ var galleries = ({
  init: galleries_init,
  initializeGalleries: initializeGalleries
});
// EXTERNAL MODULE: ./js/Authenticated.js
var Authenticated = __webpack_require__(1034);

// CONCATENATED MODULE: ./js/components/email_capture_footer_form.js


var email_capture_footer_form_showFailure = function showFailure() {
  Object(jquery["default"])('.js-email-capture-footer-form-failure').fadeIn('fast');
};

var email_capture_footer_form_showThanks = function showThanks(response) {
  if (response.status !== 'success') {
    email_capture_footer_form_showFailure();
    return;
  }

  Object(jquery["default"])('.js-email-capture-footer-form-failure').fadeOut('fast');
  Object(jquery["default"])('.js-email-capture-footer-form-initial').fadeOut('fast', function () {
    Object(jquery["default"])('.js-email-capture-footer-form-thanks').fadeIn('fast');
  });
};

var email_capture_footer_form_initializeEmailCaptureForm = function initializeEmailCaptureForm() {
  Object(jquery["default"])('.js-email-capture-form').ajaxForm({
    success: email_capture_footer_form_showThanks
  });
};

var email_capture_footer_form_init = function init() {
  email_capture_footer_form_initializeEmailCaptureForm();
};

/* harmony default export */ var email_capture_footer_form = ({
  init: email_capture_footer_form_init
});
// EXTERNAL MODULE: ./js/InternalReferrer.js
var InternalReferrer = __webpack_require__(1041);

// EXTERNAL MODULE: ../utilities/device.js
var device = __webpack_require__(443);

// EXTERNAL MODULE: ../utilities/deeplink.js
var deeplink = __webpack_require__(856);

// EXTERNAL MODULE: ../globals/dataLayer.js
var dataLayer = __webpack_require__(170);

// EXTERNAL MODULE: ../utilities/userAgent.js
var userAgent = __webpack_require__(70);

// CONCATENATED MODULE: ./js/AppInstallBanner.js
function AppInstallBanner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AppInstallBanner__objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AppInstallBanner_ownKeys(Object(source), true).forEach(function (key) { AppInstallBanner__defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AppInstallBanner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AppInstallBanner__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }









var AppInstallBanner__default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "closeBanner",
    value: function closeBanner() {
      Object(jquery["default"])('.js-app-banner').addClass('hidden');
      Object(jquery["default"])('body').removeClass('has-banner');
      jquery["default"].cookie('appBanner', true, {
        expires: 90
      });
    }
  }, {
    key: "fireClickEvent",
    value: function fireClickEvent() {
      dataLayer["a" /* default */].push({
        event: 'mobile-web-app-download-install'
      });
    }
  }, {
    key: "isPossibleBanner",
    value: function isPossibleBanner() {
      return !jquery["default"].cookie('appBanner');
    }
  }, {
    key: "init",
    value: function init() {
      if (!Object(device["isMobileBrowser"])() || !this.isPossibleBanner() || Object(userAgent["f" /* isMobileEmbedded */])() || Object(jquery["default"])('body').hasClass('no-banner') || !Rover["default"].context.supportsMobileApp) {
        return;
      }

      var appInstallBannerShownEvent = {
        event: 'navigation-app-install-banner-shown',
        nonInteractive: true
      };

      var reviewsText = translation["default"]._(
      /*i18n*/
      {
        id: "Reviews"
      });

      Rover["default"].context.iOSReviewCount = "76.8k+ ".concat(reviewsText);
      Rover["default"].context.androidReviewCount = "4,300+ ".concat(reviewsText);
      dataLayer["a" /* default */].push(AppInstallBanner__objectSpread({}, appInstallBannerShownEvent));
      var routeURL = Object(deeplink["a" /* getRouteURL */])();
      Object(jquery["default"])('body').addClass('has-banner');
      Object(jquery["default"])('.js-app-banner').removeClass('hidden');
      Object(jquery["default"])('.js-app-install-link').attr('href', routeURL);
      Object(jquery["default"])('.js-app-install-link').on('click', this.fireClickEvent);
      Object(jquery["default"])('.js-close-app-banner').on('click', this.closeBanner);

      if (Object(userAgent["a" /* isAndroid */])()) {
        Object(jquery["default"])('.js-review-count').text(Rover["default"].context.androidReviewCount);
      } else {
        Object(jquery["default"])('.js-review-count').text(Rover["default"].context.iOSReviewCount);
      }
    }
  }]);

  return _default;
}();


// EXTERNAL MODULE: ../utilities/cookie/index.client.js + 4 modules
var index_client = __webpack_require__(319);

// CONCATENATED MODULE: ../utilities/lever.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || lever__unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function lever__unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return lever__arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return lever__arrayLikeToArray(o, minLen); }

function lever__arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var leverCookies = {
  'lever-origin': 'applied',
  'lever-source': 'Site_Footer'
};

var lever_createCookieFromObj = function createCookieFromObj(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return Object(index_client["a" /* createCookie */])(key, value, 30);
};

var setLeverCookies = function setLeverCookies() {
  return Object.entries(leverCookies).map(lever_createCookieFromObj);
};

/* harmony default export */ var lever = (setLeverCookies);
// CONCATENATED MODULE: ./js/components/footer.js



var footer_init = function init() {
  Object(jquery["default"])(document).on('click', '.js-careers-link-click-listener', lever);
};

/* harmony default export */ var footer = ({
  init: footer_init
});
// CONCATENATED MODULE: ./js/application.js




















 // This stays outside the IIFE since it needs to
// fire events before Vue components are loaded

Object(jquery["default"])(function () {
  InternalReferrer["a" /* default */].init();
  ajax.init();
  email_capture_footer_form.init();
  AppInstallBanner__default.init();
  footer.init();
  auth["a" /* default */].init();
  buttons.init();
  carousels.init();
  events["a" /* default */].init();
  flag_listing.init();
  gus_tips.init();
  modals.init();
  text_utilities.init();
  validation["a" /* default */].init();
  console.init();
  galleries.init();
  jquery_fixes.init();
  Authenticated["a" /* default */].init();
  utilities_loadNavigationEventsIntoDataLayer();
  utilities_applyNavigationEventClickHandlers();
});

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return snakeify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return camelizeString; });
/* unused harmony export snakeifyString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return kebabifyString; });
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable filenames/match-regex */
var camelizeString = function camelizeString() {
  var snakeString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return snakeString.trim().replace(/(-|_|\s)+(.)?/g, function (_match, _sep, c) {
    return c ? c.toUpperCase() : '';
  });
};

var camelize = function camelize() {
  var snakeData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var blacklist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var camelData = Array.isArray(snakeData) ? [] : {};
  Object.keys(snakeData).forEach(function (key) {
    var camelKey = blacklist.includes(key) ? key : camelizeString(key, blacklist);

    if (recursive && snakeData[key] && _typeof(snakeData[key]) === 'object') {
      camelData[camelKey] = camelize(snakeData[key], true, blacklist);
    } else {
      camelData[camelKey] = snakeData[key];
    }
  });
  return camelData;
};

var snakeifyString = function snakeifyString() {
  var camelString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return camelString.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
};

var snakeify = function snakeify() {
  var camelData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var snakeData = Array.isArray(camelData) ? [] : {};
  Object.keys(camelData).forEach(function (key) {
    var snakeKey = snakeifyString(key);

    if (recursive && camelData[key] && _typeof(camelData[key]) === 'object') {
      snakeData[snakeKey] = snakeify(camelData[key], true);
    } else {
      snakeData[snakeKey] = camelData[key];
    }
  });
  return snakeData;
};

var kebabifyString = function kebabifyString() {
  var camelString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return camelString.trim().replace(/([a-z\d])([A-Z]+)/g, '$1-$2').replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1-$2').replace(/[_\s]+/g, '-').toLowerCase();
};



/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_dataLayer__ = __webpack_require__(170);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var pushEvent = function pushEvent(event) {
  return new Promise(function (resolve) {
    // Use setTimeout to ensure the main CPU thread is freed up between invocations of GTM
    setTimeout(function () {
      return __WEBPACK_IMPORTED_MODULE_0__rover_globals_dataLayer__["a" /* default */].push(_objectSpread(_objectSpread({}, event), {}, {
        eventCallback: resolve
      }));
    });
  });
};

var fireDataLayerEvent = function fireDataLayerEvent(event) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  return Promise.race([pushEvent(event), // GTM may be blocked or the script may fail to process the queue.
  // In those cases the above event promise will never resolve, so provide
  // a failsafe
  new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  })]);
};

/* harmony default export */ __webpack_exports__["a"] = (fireDataLayerEvent);

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../utilities/appendUrlParams.js
var appendUrlParams = __webpack_require__(493);

// CONCATENATED MODULE: ../utilities/utm/utm.constants.js
var UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
// CONCATENATED MODULE: ../utilities/utm/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utm_addUtmParamsToUrl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return UTM_PARAMS; });


var encodeUtmParams = function encodeUtmParams(rawUtmParams) {
  var res = rawUtmParams;
  Object.keys(res).forEach(function (key) {
    res[key] = encodeURIComponent(rawUtmParams[key]);
  });
  return res;
};

var utm_addUtmParamsToUrl = function addUtmParamsToUrl(utmParams, url) {
  if (!utmParams || !utmParams.utm_source || !utmParams.utm_source.length) return url; // utm_source is required: https://ga-dev-tools.appspot.com/campaign-url-builder/

  return Object(appendUrlParams["a" /* default */])(url, encodeUtmParams(utmParams));
};


/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_globals_Mustache__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rover_globals_dataLayer__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rover_globals_Rover__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__ = __webpack_require__(307);
/**
 * A photo gallery modal built using a royal slider(http://dimsemenov.com/plugins/royal-slider/documentation/)
 * inside of a chromeless Bootstrap modal (see .rover-media-modal)
 *
 * Example usage:
 *
 * import GalleryModalView from 'gallery_modal';
 *
 * const gallery = new GalleryModalView({
 *     slides: [
 *         { type: "image", src: "something.jpg", caption: "A photo of something" },
 *         { type: "image", src: "something2.jpg", caption: "Another photo of something" }
 *     ]
 * });
 *
 * // Open the gallery
 * gallery.open();
 *
 * // Open the gallery to 5th slide
 * gallery.openTo(4)
 *
 */






/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */].extend({
  slideTemplates: {
    image: __WEBPACK_IMPORTED_MODULE_2__rover_globals_Mustache__["default"].template('new_design/common/media_gallery/image'),
    video: __WEBPACK_IMPORTED_MODULE_2__rover_globals_Mustache__["default"].template('new_design/common/media_gallery/video')
  },
  defaults: {
    classes: '',
    slides: []
  },
  initialize: function initialize(options) {
    this.options = __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].extend({}, this.defaults, options);
    this.options.classes += ' rover-media-modal'; // Since this modal is full-screen, we don't want scrollfixes

    this.options.applyScrollFix = false;
    __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */].prototype.initialize.call(this, this.options);
  },
  render: function render() {
    __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */].prototype.render.call(this);
    this.$modalContent.addClass('rover-media-gallery royalSlider'); // Build up gallery markup

    var markup = this.getGalleryMarkup(this.options.slides); // Inject markup into modal

    this.setContent(markup); // Instantiate slider

    this.royalSlider = this.$modalContent.royalSlider({
      autoScaleSlider: false,
      controlNavigation: 'none',
      globalCaption: true,
      keyboardNavEnabled: true,
      numImagesToPreload: 2
    }).data('royalSlider');

    if (this.royalSlider) {
      this.initVideoSupport();
    }
  },
  // Adapted from http://help.dimsemenov.com/kb/royalslider-javascript-api/adding-support-for-third-party-video-player
  initVideoSupport: function initVideoSupport() {
    var _this = this;

    var slider = this.royalSlider;
    var videoPlayer;
    slider.ev.on('rsOnCreateVideoElement', function (e, videoSrc) {
      slider.videoObj = Object(__WEBPACK_IMPORTED_MODULE_0__rover_globals_jquery__["default"])('<div class="rsVideoObj"></div>');

      __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].defer(function () {
        var currSlide = e.target.currSlide;
        var h = currSlide.iH;
        var w = currSlide.iW;
        var backupSrc = currSlide.content.data('video-backup-src');
        videoPlayer = __WEBPACK_IMPORTED_MODULE_4__rover_globals_Rover__["default"].video.player({
          container: slider.videoObj,
          width: '100%',
          aspectRatio: "".concat(w, ":").concat(h),
          autoPlay: true
        });
        videoPlayer.load(videoSrc, backupSrc);
      });
    });
    slider.ev.on('rsOnDestroyVideoElement', function (e) {
      videoPlayer.remove();
    });
    slider.ev.on('rsAfterSlideChange', function (e) {
      _this.recordViewEvent();
    });
  },
  recordViewEvent: function recordViewEvent() {
    var eventName = this.options.recordedEvent;

    if (!eventName) {
      return;
    }

    var slide = this.options.slides[this.royalSlider.currSlideId];
    var opk = slide ? slide.opk : '';
    __WEBPACK_IMPORTED_MODULE_3__rover_globals_dataLayer__["a" /* default */].push({
      event: eventName,
      imageId: opk,
      providerId: __WEBPACK_IMPORTED_MODULE_4__rover_globals_Rover__["default"].context.providerId
    });
  },
  onModalShown: function onModalShown() {
    this.royalSlider.updateSliderSize();
    __WEBPACK_IMPORTED_MODULE_5__components_rover_modal__["a" /* default */].prototype.onModalShown.call(this);
    this.recordViewEvent();
  },
  openTo: function openTo(index) {
    this.royalSlider.goTo(index);
    this.open();
  },
  getSlideMarkup: function getSlideMarkup(slide) {
    return this.slideTemplates[slide.type].render(slide);
  },
  getGalleryMarkup: function getGalleryMarkup(slides) {
    var _this2 = this;

    var markup = '';

    __WEBPACK_IMPORTED_MODULE_1__rover_globals_underscore__["default"].each(slides, function (slide) {
      markup += _this2.getSlideMarkup(slide);
    });

    return markup;
  }
}));

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appendFirstHttpReferrer */
/* unused harmony export appendAmbassador */
/* unused harmony export appendRoverCid */
/* unused harmony export appendAloomaDistinctId */
/* unused harmony export generateRouteUrl */
/* unused harmony export getRouteUrlContextless */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRouteURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rover_utilities_appendUrlParams__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rover_utilities_object_utilities__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rover_utilities_utm__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getUrlParameter__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cookie__ = __webpack_require__(319);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // Appends the URL of the first http referrer for the given session, used for attribution

var appendFirstHttpReferrer = function appendFirstHttpReferrer(deepLinkWithParams, firstHttpReferrer) {
  if (!firstHttpReferrer) return deepLinkWithParams;
  return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_appendUrlParams__["a" /* default */])(deepLinkWithParams, {
    http_referrer: encodeURIComponent(firstHttpReferrer)
  });
}; // Appends UTM tracking data for Ambassador referral tracking: https://www.getambassador.com/

var appendAmbassador = function appendAmbassador(deepLinkWithParams) {
  var ambassadorMbsyCode = Object(__WEBPACK_IMPORTED_MODULE_3__getUrlParameter__["a" /* default */])('mbsy');
  if (!ambassadorMbsyCode) return deepLinkWithParams;
  var promoCode = Object(__WEBPACK_IMPORTED_MODULE_3__getUrlParameter__["a" /* default */])('promo_code');
  var utmSource = Object(__WEBPACK_IMPORTED_MODULE_3__getUrlParameter__["a" /* default */])('utm_source');
  var utmContent = Object(__WEBPACK_IMPORTED_MODULE_3__getUrlParameter__["a" /* default */])('utm_content');

  var extraAmbassadorParams = _objectSpread(_objectSpread(_objectSpread({
    mbsy: ambassadorMbsyCode,
    campaignid: Object(__WEBPACK_IMPORTED_MODULE_3__getUrlParameter__["a" /* default */])('campaignid') || ''
  }, promoCode && {
    promoCode: promoCode
  }), utmSource && {
    utmSource: utmSource
  }), utmContent && {
    utmContent: utmContent
  });

  return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_appendUrlParams__["a" /* default */])(deepLinkWithParams, Object(__WEBPACK_IMPORTED_MODULE_1__rover_utilities_object_utilities__["d" /* snakeify */])(extraAmbassadorParams));
}; // Appends the rover_cid, used in analytics to uniquely identify a device across sessions

var appendRoverCid = function appendRoverCid(deepLinkWithParams) {
  var roverCid = Object(__WEBPACK_IMPORTED_MODULE_4__cookie__["b" /* getCookie */])('rover_cid');
  if (!roverCid) return deepLinkWithParams;
  return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_appendUrlParams__["a" /* default */])(deepLinkWithParams, {
    rover_cid: roverCid
  });
}; // Appends the Alooma ID, used by Alooma to uniquely identify a device across sessions

var appendAloomaDistinctId = function appendAloomaDistinctId(deepLinkWithParams) {
  var aloomaCookie = Object(__WEBPACK_IMPORTED_MODULE_4__cookie__["b" /* getCookie */])('mp_rover_alooma');

  if (aloomaCookie) {
    var aloomaDistinctId = JSON.parse(decodeURIComponent("".concat(aloomaCookie))).distinct_id;

    if (aloomaDistinctId) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_appendUrlParams__["a" /* default */])(deepLinkWithParams, {
        distinct_id: aloomaDistinctId
      });
    }
  }

  return deepLinkWithParams;
}; // Generates a URL used for Branch.IO deeplinking: https://branch.io/

var generateRouteUrl = function generateRouteUrl(deepLinkWithParams, branchKey) {
  var afterClickUrl = encodeURIComponent(window.location.href);
  var deeplinkPath = encodeURIComponent(deepLinkWithParams.split('rover://')[1]);
  return Object(__WEBPACK_IMPORTED_MODULE_0__rover_utilities_appendUrlParams__["a" /* default */])("https://r.rover.com/a/".concat(branchKey), {
    $deeplink_path: deeplinkPath,
    $after_click_url: afterClickUrl
  });
}; // A function for getting an app deep link URL, without dependencies on window globals

var getRouteUrlContextless = function getRouteUrlContextless() {
  var deepLink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rover://campaign/';
  var utmParams = arguments.length > 1 ? arguments[1] : undefined;
  var firstHttpReferrer = arguments.length > 2 ? arguments[2] : undefined;
  var branchKey = arguments.length > 3 ? arguments[3] : undefined;
  var deepLinkWithParams = deepLink;
  deepLinkWithParams = Object(__WEBPACK_IMPORTED_MODULE_2__rover_utilities_utm__["b" /* addUtmParamsToUrl */])(utmParams, deepLinkWithParams);
  deepLinkWithParams = appendFirstHttpReferrer(deepLinkWithParams, firstHttpReferrer);
  deepLinkWithParams = appendAmbassador(deepLinkWithParams);
  deepLinkWithParams = appendRoverCid(deepLinkWithParams);
  deepLinkWithParams = appendAloomaDistinctId(deepLinkWithParams);
  return generateRouteUrl(deepLinkWithParams, branchKey);
}; // A function for getting an app deep link URL, with dependencies on window globals

var getRouteURL = function getRouteURL() {
  var deepLink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rover://campaign/';
  var _window$Rover = window.Rover,
      roverDeepLink = _window$Rover.deeplink,
      branchKey = _window$Rover.context.branchKey,
      utmParams = _window$Rover.UTMParameters,
      firstHttpReferrer = _window$Rover.firstHttpReferrer;
  return getRouteUrlContextless(roverDeepLink || deepLink, utmParams, firstHttpReferrer, branchKey);
};
/* unused harmony default export */ var _unused_webpack_default_export = (getRouteUrlContextless);

/***/ })

},[1555]);


// WEBPACK FOOTER //
// application_js.852407a32bedd0d2.js